import { BookOpen, Download, Files } from "lucide-react";
import { FaCloudArrowDown, FaFilePdf } from "react-icons/fa6";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "@/components/ui/card";
import { web as web2026, web2025 } from "@/config/System";
import { useSearchParams } from "react-router-dom";

export default function DaftarUnduhan() {
  const [searchParams] = useSearchParams();
  const tahunParams = searchParams.get("tahun");

  let web;
  switch (tahunParams) {
    case "2025":
      web = web2025;
      break;
    case "2026":
      web = web2026;
      break;
    default:
      web = web2026;
      break;
  }

  const listUnduhan2025 = [
    {
      id: "panduan",
      title: "Panduan Pengguna",
      description:
        "Dokumen teknis tata cara pendaftaran dan penggunaan sistem.",
      iconSection: <Files className="w-5 h-5" />,
      items: [
        {
          name: "Panduan Pendaftaran Pascasarjana",
          size: "PDF",
          link: "/panduan/Pascasarjana.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SNBP",
          size: "PDF",
          link: "/panduan/Panduan_SNBP.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SNBT",
          size: "PDF",
          link: "/panduan/Panduan_Pendaftaran_Kembali_SNBT_2025.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SMBJM CBT",
          size: "PDF",
          link: "/panduan/Panduan-Pendaftaran-Kembali-Jalur Mandiri-CBT.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SMBJM Nilai Raport & Talentscouting",
          size: "PDF",
          link: "/panduan/Panduan-Pendaftaran-Kembali-Jalur Mandiri-Raport-Talent.pdf",
        },
        {
          name: "Panduan Teknis Pendaftaran Kembali",
          size: "PDF",
          link: "/panduan/Panduan_Teknis_Daftar_Kembali.pdf",
        },
      ],
    },
    {
      id: "pedoman",
      title: "Pedoman Akademik",
      description:
        "Acuan dasar penilaian dan regulasi penerimaan mahasiswa baru.",
      iconSection: <BookOpen className="w-5 h-5" />,
      items: [
        {
          name: "Pedoman Penilaian SNBP 2025",
          size: "PDF",
          link: "/pedoman/Pedoman-Penilaian-SNBP-Tahun-2025.pdf",
        },
        {
          name: "Pedoman SMBJM 2025",
          size: "PDF",
          link: web.linkPedomanSMBJM,
        },
      ],
    },
  ];

  const listUnduhan2026 = [
    {
      id: "panduan",
      title: "Panduan Pengguna",
      description:
        "Dokumen teknis tata cara pendaftaran dan penggunaan sistem.",
      iconSection: <Files className="w-5 h-5" />,
      items: [
        {
          name: "Panduan Pendaftaran SMBJM 2026",
          size: "PDF",
          link: "/panduan/Panduan_Pendaftaran_SMBJM_2026.pdf",
        },
        {
          name: "Panduan Pendaftaran Pascasarjana",
          size: "PDF",
          link: "/panduan/Pascasarjana.pdf",
        },
        {
          name: "Panduan Teknis Pendaftaran Kembali",
          size: "PDF",
          link: "/panduan/Panduan_Teknis_Daftar_Kembali.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SNBP",
          size: "PDF",
          link: "/panduan/Panduan-Pendaftaran-Kembali-SNBP-2026rv1.pdf",
        },
        {
          name: "Panduan Pendaftaran Kembali SNBT",
          size: "PDF",
          link: "/panduan/Panduan-Pendaftaran-Kembali-SNBT-2026rv1.pdf",
        },
      ],
    },
    {
      id: "pedoman",
      title: "Pedoman Akademik",
      description:
        "Acuan dasar penilaian dan regulasi penerimaan mahasiswa baru.",
      iconSection: <BookOpen className="w-5 h-5" />,
      items: [
        {
          name: "Pedoman Penilaian SNBP 2026",
          size: "PDF",
          link: "/pedoman/Pedoman-Penilaian-SNBP-Tahun-2026.pdf",
        },
        {
          name: "Pedoman SMBJM 2026",
          size: "PDF",
          link: web.linkPedomanSMBJM,
        },
      ],
    },
  ];

  let listUnduhan;
  switch (tahunParams) {
    case "2025":
      listUnduhan = listUnduhan2025;
      break;
    case "2026":
      listUnduhan = listUnduhan2026;
      break;
    default:
      listUnduhan = listUnduhan2026;
      break;
  }

  return (
    <section
      id="daftar-unduhan"
      className="py-20 min-h-screen bg-white dark:bg-slate-950 transition-colors duration-300"
    >
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header Page */}
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <Badge
            variant="outline"
            className="border-blue-200 text-blue-700 bg-blue-50 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-800"
          >
            <FaCloudArrowDown className="mr-2" />
            Pusat Unduhan
          </Badge>
          <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
            Dokumen & Panduan
          </h1>
          <p className="text-slate-500 dark:text-slate-400 text-lg">
            Akses dan unduh seluruh dokumen resmi terkait prosedur pendaftaran
            mahasiswa baru di {web.univ}.
          </p>
        </div>

        {/* Content Loop */}
        <div className="space-y-20">
          {listUnduhan.map((section, idx) => (
            <div key={idx} className="space-y-8">
              {/* Section Header */}
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 pb-4 border-b border-slate-200 dark:border-slate-800">
                <div className="flex-shrink-0 w-14 h-14 bg-white dark:bg-slate-900 border border-slate-100 dark:border-slate-800 rounded-2xl shadow-sm flex items-center justify-center text-blue-600 dark:text-blue-400">
                  {section.iconSection}
                </div>
                <div>
                  <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-1">
                    {section.title}
                  </h2>
                  <p className="text-slate-500 dark:text-slate-400 text-sm">
                    {section.description}
                  </p>
                </div>
              </div>

              {/* Grid Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
                {section.items.map((item, itemIdx) => (
                  <Card
                    key={itemIdx}
                    // Menerapkan glassmorphism, hover translate, dan hover shadow yang konsisten
                    className="group relative flex flex-col justify-between h-full overflow-hidden transition-all duration-500 border-slate-200/60 dark:border-slate-800/60 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl shadow-sm hover:-translate-y-1.5 hover:border-blue-300 dark:hover:border-blue-700 hover:shadow-[0_8px_30px_rgb(59,130,246,0.15)]"
                  >
                    {/* Top Accent Line (Samakan dengan Jalur Seleksi) */}
                    <div className="absolute top-0 left-0 w-full h-1.5 opacity-80 bg-primary dark:bg-primary transition-transform origin-left scale-x-75 group-hover:scale-x-100 duration-500" />

                    <CardHeader className="p-6 pb-4">
                      <div className="flex justify-between items-start mb-4">
                        {/* Ikon PDF dengan style yang konsisten */}
                        <div className="w-12 h-12 rounded-xl bg-red-50 dark:bg-red-500/10 text-red-500 dark:text-red-400 flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:-rotate-3">
                          <FaFilePdf className="w-6 h-6" />
                        </div>
                        <Badge
                          variant="outline"
                          className="bg-slate-50 dark:bg-slate-800/50 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700 font-semibold text-xs tracking-wider"
                        >
                          {item.size} FILE
                        </Badge>
                      </div>
                      <h3 className="font-bold text-lg text-slate-800 dark:text-slate-100 leading-snug line-clamp-2 group-hover:text-primary dark:group-hover:text-primary transition-colors">
                        {item.name}
                      </h3>
                    </CardHeader>

                    <CardContent className="px-6 py-0 flex-1">
                      {/* Tempat untuk deskripsi file ekstra di masa depan */}
                    </CardContent>

                    <CardFooter className="p-6 pt-4 mt-auto">
                      <Button
                        asChild
                        variant="ghost"
                        // Style outline/ghost yang memudar menjadi biru saat di-hover
                        className="w-full border border-slate-200 dark:border-slate-800 text-slate-700 dark:text-slate-300 group-hover:border-blue-200 dark:group-hover:border-blue-800 group-hover:bg-blue-50 dark:group-hover:bg-blue-500/10 group-hover:text-blue-700 dark:group-hover:text-blue-400 transition-all duration-300"
                      >
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Download className="w-4 h-4 mr-2 transition-transform duration-300 group-hover:-translate-y-0.5" />
                          Unduh Dokumen
                        </a>
                      </Button>
                    </CardFooter>
                  </Card>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
